"use client";

import type { CSSProperties } from "react";

type NextPieceProps = {
  cells?: ReadonlyArray<readonly [number, number]>;
  label?: string;
  piece?: number;
};

export function NextPiece({ cells = [], label = "NEXT BLOCK", piece = 0 }: NextPieceProps) {
  const occupied = new Set(cells.map(([x, y]) => `${x}:${y}`));

  return (
    <div aria-label={label} className="next-panel">
      <span className="next-label">{label}</span>
      <div className="next-well">
        {Array.from({ length: 16 }, (_, index) => {
          const x = index % 4;
          const y = Math.floor(index / 4);
          const on = occupied.has(`${x}:${y}`);
          return (
            <span
              aria-hidden="true"
              className={`next-cell${on ? " tile active-tile" : ""}`}
              key={index}
              style={({ "--piece": on ? piece : 0 } as CSSProperties)}
            />
          );
        })}
      </div>
    </div>
  );
}

